import { Parts, SurveyWindow } from 'store/surveyWindow/types'

export const useHadFullSurvey = (archive?: SurveyWindow[]) => {
  const latestSurveyWindow = archive?.[0]
  const previousSurveyWindow = archive?.[1]

  if (!archive) {
    return { hadFullSurvey: false }
  }

  const hadFullSurvey =
    latestSurveyWindow?.parts.includes(Parts.IS) ||
    latestSurveyWindow?.parts.includes(Parts.PP) ||
    previousSurveyWindow?.parts.includes(Parts.IS) ||
    previousSurveyWindow?.parts.includes(Parts.PP)

  return { hadFullSurvey }
}
